import React, { useEffect, useState } from 'react';
import { Header, Table, Message, Button, Toast } from 'react-frontier';
import { Payout } from '../Classes';
import { addCommas, bindFormChange } from '@tempu/components/Util';
import { Checkbox } from 'semantic-ui-react';
import Modal from './Modal';
import classNames from 'classnames';
import API from '../API';


interface ModalProps {
   open: boolean,
	payouts: Payout [],
	onClose?: ()=>void,
	onComplete: (cp: number[])=>void,
}

interface Form{
	completed: boolean,
	stp: boolean,
	payouts: Payout []
}

var PayoutModal = (props: ModalProps) => {
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [completeForm, setCompleteForm] = useState<Form>({ completed: false, stp: false, payouts: null });
	var [downloadModal, setDownloadModal] = useState(false);
	var [loading, setLoading] = useState<boolean>(false);
	var [selectedPayouts, setSelectedPayouts] = useState<number[]>([]);

	useEffect(()=>{
		if (props.payouts.length === 1) {
			setSelectedPayouts([props.payouts[0].payout_id]);
		}
	}, [props.payouts]);

	var complete = async(confirmation: boolean=false)=>{
		if(!completeForm.completed && !completeForm.stp) return setModalPrompts(['Necesitar marcar una opción para continuar.'])
		if(completeForm.stp && !confirmation){
			props.onClose();
			downloadSTP();
			return setDownloadModal(true);
		}
		setLoading(true);
		API.completePayout(selectedPayouts).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Liquidaciónes completadas!');
			if(props.onComplete){
				props.onComplete(selectedPayouts);
			}
		}).catch(err=>{
			setModalPrompts(['Hubo un error al completar las liquidaciones. (PEE-1)']);
		}).finally(()=>{
			props.onClose();
			setLoading(false);
			setDownloadModal(false);
		});
	}

	var downloadSTP = async()=>{
		API.downloadPayoutsZip(selectedPayouts).then(res=>{
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado descargando el archivo de liquidaciónes (LCL-1)']);
		});
   };

	var onCompleteFormChange = bindFormChange(completeForm, setCompleteForm);

	return <div>
		<Modal open={props.open} size='small' onClose={props.onClose}>
			<Modal.Header>Completar liquidación</Modal.Header>
			{props.payouts.length !== 0 &&  props.payouts.length <= 1 ?  <Modal.Content>
				<Header text='¿Completar liquidación?' subtext={'Marcará la liquidación como completada'}/>
				<Table
						details
						title='Información'
						data={[
							['ID', props.payouts[0].payout_id],
							['Negocio', props.payouts[0].business_name],
							['Empleo', props.payouts[0].posting_name],
							['Cantidad', '$' + addCommas(props.payouts[0].total_pending || props.payouts[0].users.reduce((total, user) => {return total + user.amount}, 0))],
							['Creador', props.payouts[0].user_creator_name]
						]}
					/>
				<Checkbox toggle checked={completeForm.completed && !completeForm.stp} label={'Esta liquidación ya se depositó'} onChange={onCompleteFormChange('completed', true)} disabled={completeForm.stp} style={{ marginTop: 15, display: 'block' }} />
				<Checkbox toggle checked={completeForm.stp && !completeForm.completed} label={'Descargar archivo STP'} onChange={onCompleteFormChange('stp', true)} disabled={completeForm.completed} style={{ marginTop: 5, display: 'block' }} />
				<Message type='error' list={modalPrompts} />
			</Modal.Content> :  <Modal.Content>
				<Table
					fitted
					selectable
					collapsingIndexes={[0, 1, 3, 4, 5]}
					centeredIndexes={[ 4 ]}
					onClick={(v: number[])=>{
						var sp = [...selectedPayouts];
						var ix = sp.indexOf(v[1]);
						if(ix==-1){
							sp.push(v[1]);
						}else{
							sp.splice(ix, 1);
						}
						setSelectedPayouts(sp);
					}}
					headers={[
						<div style={{ textAlign: 'center' }}>
							<i className="checkmark icon" style={{ marginRight: 0 }}></i>
						</div>, 
						'ID', 
						'NEGOCIO',
						'EMPLEO',
						'CANTIDAD',
						'PAGOS'
					]}
					data={props.payouts.map(a=>{
						var selected = selectedPayouts.indexOf(a.payout_id)!==-1;
						return [
							<i className={classNames('large icon circle', {
								check: selected,
								outline: !selected
							})}></i>,
							a.payout_id,
							a.business_name,
							a.posting_name,
							addCommas(a.total_pending),
							a.employees
						]
					})}
				/>
				<Checkbox toggle checked={completeForm.completed && !completeForm.stp} label={'Esta liquidación ya se depositó'} onChange={onCompleteFormChange('completed', true)} disabled={completeForm.stp} style={{ marginTop: 15, display: 'block' }} />
				<Checkbox toggle checked={completeForm.stp && !completeForm.completed} label={'Descargar archivo STP'} onChange={onCompleteFormChange('stp', true)} disabled={completeForm.completed} style={{ marginTop: 5, display: 'block' }} />
				<Message type='error' list={modalPrompts} />
			</Modal.Content>}
			<Modal.Actions>
			<Button text='Cerrar' basic onClick={props.onClose} />
			<Button text='Continuar' color='black' onClick={() => complete()} disabled={!selectedPayouts || selectedPayouts.length==0} />
			</Modal.Actions>
		</Modal>
		<Modal open={downloadModal} size="mini">
			<Modal.Header>Descarga STP</Modal.Header>
			<Modal.Content>
				<Header text='Se ha hecho la descarga de el archivo para subir a STP.'/>
				<Message type='warning' centered>
					<div style={{ fontSize: 20 , fontWeight: 'bold', marginBottom: 10 }}>Confirmar descargar</div>
					<div>En cunato se descargue el archivo y se verifique que no se tengan errores, se necesitará <b>confirmar la descarga</b> para marcar las liquidaciones como liquidadas y evitar cualquier tipo de doble deposito.</div>
					<Button style={{ marginTop: 15 }} text='Confirmar descarga' color='black' onClick={() => complete(true)} loading={loading}/>
				</Message>
				<div style={{ textAlign: 'center' , padding: 10 }}>
					<Button text='Reintentar descarga' basic onClick={downloadSTP}/>
				</div>
				<Message list={modalPrompts} type='error' />
			</Modal.Content>
		</Modal>
	</div> 
}

export default PayoutModal;